<template>
  <div>
    <l-tables
      ref="permissionTable"
      :content="content"
      :tableConfig="tableConfig"
      :searchParams="searchData"
      :noCreatText="noCreatText"
      :ImgSrc="nullImg"
      :emptyImgSrc="emptyImgSrc"
    >
      <template slot="searchConditions">
        <div class="search-conditions">
          <a-input v-model="name" @change="search" maxlength="30" :placeholder="$t('roleManagement.searchPlaceholder')" class="search-item">
            <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
            <img
              class="clear"
              v-if="name"
              slot="suffix"
              @click=";(name = undefined), search()"
              :src="require('@/assets/icons/icon_gb.png')"
            />
          </a-input>
        </div>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="goToAdd">{{ $t('roleManagement.createRole') }}</a-button>
      </template>
      <template slot="create">
        <a-button type="primary" @click="goToAdd">{{ $t('roleManagement.createRole') }}</a-button>
      </template>

      <template #name="{ record }">
        <a-tooltip>
          <template slot="title">
            <span>{{ record.name }}</span>
          </template>
          <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ record.name }}</div>
        </a-tooltip>
      </template>
      <template #username="{ record }">
        <div class="username">
          <!-- <span v-for="(item, index) in record.username" :key="index">
            {{ item }}
            <span v-if="index !== record.username.length - 1">、</span>
          </span>
          -->
          <span v-if="record.username.length === 0">--</span>
          <a-tooltip v-else>
            <template slot="title">
              <span>{{ record.username.join('、') }}</span>
            </template>
            <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; ">
              {{ record.username.join('、') }}
            </div>
          </a-tooltip>
        </div>
      </template>
      <!-- <template #operateCustom="{ record }">
        <div class="operate">
          <a-button type="link" @click="goToEdit(record)">
            <span>{{ $t('roleManagement.edit') }}</span>
          </a-button>
          <a-button type="link" @click="delModal(record.id)">
            <span>{{ $t('roleManagement.delete') }}</span>
          </a-button>
        </div>
      </template> -->
    </l-tables>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import { i18nRender } from '@/locales'

export default {
  components: {
    LTables
  },
  data() {
    return {
      name: undefined,
      noCreatText: i18nRender('roleManagement.noRole'),
      nullImg: require('@/assets/img/trainingRoomlistNull.png'),
      emptyImgSrc: require('@/assets/img/bj_zanwu_2.png'),
      searchData: {
        keyword: ''
      },
      content: 'permission',
      tableConfig: {
        tableName: i18nRender('roleManagement.tableName'),
        tableColumns: [
          {
            title: i18nRender('roleManagement.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center'
          },
          {
            title: i18nRender('roleManagement.roleName'),
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            scopedSlots: { customRender: 'name' }
          },
          {
            title: i18nRender('roleManagement.userList'),
            dataIndex: 'username',
            key: 'username',
            align: 'center',
            scopedSlots: { customRender: 'username' }
          },
          {
            title: i18nRender('roleManagement.operation'),
            dataIndex: 'operate',
            key: 'operate',
            width: 200,
            align: 'center',
            scopedSlots: { customRender: 'operate' }
          }
        ],
        tableDeleteTip: {
          title: i18nRender('roleManagement.deleteConfirmTitle'),
          content: i18nRender('roleManagement.deleteConfirmContent')
        },
        tablePort: {
          list: '/admin/role/list',
          del: '/admin/role/delete'
        },
        tableEditRouteNName: 'systemPermissionAdd'
      },
      modalVisible: false,
      formTitle: i18nRender('roleManagement.newRole'),
      currentEditData: null
    }
  },
  methods: {
    search() {
      this.searchData.keyword = this.name
    },
    create() {
      this.formTitle = i18nRender('roleManagement.newRole')
      this.currentEditData = null
      this.modalVisible = true
    },
    editRole(record) {
      this.formTitle = i18nRender('roleManagement.editRole')
      this.currentEditData = { ...record }
      this.modalVisible = true
    },
    handleModalCancel() {
      this.modalVisible = false
    },
    handleModalSuccess() {
      this.modalVisible = false
      this.$refs.permissionTable.getList()
    },
    goToAdd() {
      this.$router.push({
        name: 'systemPermissionAdd'
      })
    },

    goToEdit(record) {
      this.$router.push({
        name: 'systemPermissionAdd',
        query: { id: record.id }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.search-conditions {
  display: flex;
  align-items: center;
  .search-item {
    margin-right: 16px;
  }
}
/deep/ .operate {
  display: flex;
  justify-content: center;
  button {
    padding: 0 4px;
  }
}
</style>